<script lang="ts">
  interface Props {
    row: string[];
  }

  let { row }: Props = $props();
</script>

{#if row}
  <tr class="table-row">
    {#each row as col}
      <td class="table-data"><div class="cell-val">{col}</div></td>
    {/each}
  </tr>
{/if}

<style>
  .table-data {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    min-width: 100px;
    background-color: #fff;
  }
  .cell-val {
    width: max-content;
  }
</style>
